import {GetAssignmentTypes, CreateAssignmentType} from "../../../api/AssignmentTypeApi";
import {GetDaysOfWeek, CreateDayOfWeek} from "../../../api/DayOfWeekApi";
import {AssignmentTypeInputs} from "../../AssigmentType/AssignmentTypeInputs";
import {DayOfWeekInputs} from "../../DayOfWeek/DayOfWeekInputs";

export const AssignmentRoutineInputs = [
  { name: 'name', label: "Name", type: 'text', defaultValue: '', validation: { required: "Please enter a name" } },
  { name: 'instructions', label: "Instructions", type: 'text', defaultValue: '', validation: { required: "Please enter some instructions" } },
  { name: 'timeToComplete', label: "Time to Complete (minutes)", type: 'number', defaultValue: 60 },
  {
    name: 'assignmentType',
    label: 'Assignment Type',
    getItems: GetAssignmentTypes,
    optionValue: 'name',
    validation: {
      required: true,
      validate: val => val.name ? true : 'Please choose a type' },
    type: 'autocomplete',
    defaultValue: { name: '' },
    inputs: AssignmentTypeInputs,
    addNew: CreateAssignmentType
  },
  {
    name: 'dayOfWeek',
    label: 'Day of Week',
    getItems: GetDaysOfWeek,
    optionValue: 'name',
    validation: {
      required: true,
      validate: val => val.name ? true : 'Please choose a type' },
    type: 'autocomplete',
    defaultValue: { name: '' },
    inputs: DayOfWeekInputs,
    addNew: CreateDayOfWeek
  },
  {
    name: 'occurrenceType',
    type: 'hidden',
    defaultValue: 'template'
  }
];